/** Brand name for Google site-name / schema.org WebSite. */
export const PRICEME_SITE_NAME = "PriceMe";

/** Homepage `<title>` and primary branded SERP headline. */
export const PRICEME_HOME_PAGE_TITLE = "PriceMe | The Home Price Guessing Game";

/** Homepage meta description (puzzle product; not Classic). */
export const PRICEME_HOME_PAGE_DESCRIPTION =
    "Scroll through spectacular homes and guess the prices. You get 6 tries to guess the price of each property.";

/** External profiles that disambiguate PriceMe from other brands (schema.org `sameAs`). */
export const PRICEME_SAME_AS_URLS: readonly string[] = ["https://www.reddit.com/r/PriceMe/"];
